import { render, staticRenderFns } from "./PackagingSplitModal.vue?vue&type=template&id=258f07b0&scoped=true"
import script from "./PackagingSplitModal.vue?vue&type=script&lang=js"
export * from "./PackagingSplitModal.vue?vue&type=script&lang=js"
import style0 from "./PackagingSplitModal.vue?vue&type=style&index=0&id=258f07b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258f07b0",
  null
  
)

export default component.exports